export const GET_EXPRESS_CHECKOUT_DETAILS = 'GET_EXPRESS_CHECKOUT_DETAILS';
export const GET_CHECKOUT_DETAILS_SUCCESS = 'GET_CHECKOUT_DETAILS_SUCCESS';
export const GET_CHECKOUT_DETAILS_RESPONSE = 'GET_CHECKOUT_DETAILS_RESPONSE';
export const EXPRESS_CHECKOUT_DETAILS_PREFETCH = 'EXPRESS_CHECKOUT_DETAILS_PREFETCH';
// export const CALL_EXPRESS_CHECKOUT_API = 'CALL_EXPRESS_CHECKOUT_API';
export const EXPRESS_CHECKOUT_API_SUCCESS = 'EXPRESS_CHECKOUT_API_SUCCESS';
export const EXPRESS_CHECKOUT_API_FAILURE = 'EXPRESS_CHECKOUT_API_FAILURE';

export const VALIDATE_EMAIL = 'VALIDATE_EMAIL';
export const VERIFY_EMAIL_API = 'VERIFY_EMAIL_API';
export const VALIDATE_MOBILE = 'VALIDATE_MOBILE';
export const VALIDATE_MOBILE_NO = 'VALIDATE_MOBILE_NO';
export const UPDATE_ABOUT_YOURSELF_FORM = 'UPDATE_ABOUT_YOURSELF_FORM';
export const VERIFY_EMAIL_MANUAL = 'VERIFY_EMAIL_MANUAL';
export const CONTACT_INFO_ERRORS = 'CONTACT_INFO_ERRORS';
export const CONTACT_INFO_ERRORS_SUCCESS = 'CONTACT_INFO_ERRORS_SUCCESS';

export const EXPRESS_CHECKOUT_ADDREMOVE_ACCESSORY = 'EXPRESS_CHECKOUT_ADDREMOVE_ACCESSORY';
export const EXPRESS_CHECKOUT_ADDREMOVE_ACCESSORY_SUCCESS = 'EXPRESS_CHECKOUT_ADDREMOVE_ACCESSORY_SUCCESS';
export const EXPRESS_CHECKOUT_ADDREMOVE_ACCESSORY_FAILURE = 'EXPRESS_CHECKOUT_ADDREMOVE_ACCESSORY_FAILURE';

export const EXPRESS_CHECKOUT_ADD_REMOVE_YTTV = 'EXPRESS_CHECKOUT_ADD_REMOVE_YTTV';
export const EXPRESS_CHECKOUT_ADD_REMOVE_YTTV_SUCCESS = 'EXPRESS_CHECKOUT_ADD_REMOVE_YTTV_SUCCESS';
export const EXPRESS_CHECKOUT_ADD_REMOVE_YTTV_FAILURE = 'EXPRESS_CHECKOUT_ADD_REMOVE_YTTV_FAILURE';

export const EXPRESS_CHECKOUT_VALIDATE_PROMO_CODE = 'EXPRESS_CHECKOUT_VALIDATE_PROMO_CODE';
export const EXPRESS_CHECKOUT_VALIDATE_PROMO_CODE_SUCCESS = 'EXPRESS_CHECKOUT_VALIDATE_PROMO_CODE_SUCCESS';
export const EXPRESS_CHECKOUT_VALIDATE_PROMO_CODE_FAILURE = 'EXPRESS_CHECKOUT_VALIDATE_PROMO_CODE_FAILURE';
export const UPDATE_DAW_COUPON_DISCOUNT = 'UPDATE_DAW_COUPON_DISCOUNT';

export const EXPRESS_CHECKOUT_ACCOUNT_OWNER_EMAIL = 'EXPRESS_CHECKOUT_ACCOUNT_OWNER_EMAIL';
export const EXPRESS_CHECKOUT_ACCOUNT_OWNER_EMAIL_SUCCESS = 'EXPRESS_CHECKOUT_ACCOUNT_OWNER_EMAIL_SUCCESS';
export const EXPRESS_CHECKOUT_ACCOUNT_OWNER_EMAIL_FAILURE = 'EXPRESS_CHECKOUT_ACCOUNT_OWNER_EMAIL_FAILURE';
export const EXPRESS_CHECKOUT_ACCOUNT_OWNER_EMAIL_RESET = 'EXPRESS_CHECKOUT_ACCOUNT_OWNER_EMAIL_RESET';

export const EXPRESS_CHECKOUT_CONTACT_FORM_UNSAVED = 'EXPRESS_CHECKOUT_CONTACT_FORM_UNSAVED';
export const UPDATE_PROCESS_STEP_EC = 'UPDATE_PROCESS_STEP_EC';

export const UPDATE_PROCESS_EC = 'UPDATE_PROCESS_EC';
export const VALIDATE_ORDER = 'VALIDATE_ORDER';

export const SETUP_OPTION_HANDLER = 'SETUP_OPTION_HANDLER';

export const DELETE_CART = 'DELETE_CART';

export const EC_EMAIL_VALIDATE_API = 'EC_EMAIL_VALIDATE_API';
export const EC_EMAIL_VALIDATE_API_RESPONSE = 'EC_EMAIL_VALIDATE_API_RESPONSE';

export const GET_CHECKOUT_DETAILS_CREDIT_PAGE = 'GET_CHECKOUT_DETAILS_CREDIT_PAGE';

export const GET_SHIPPING_API = 'GET_SHIPPING_API';

export const SHIPPING_ADDRESS_CONTINUE_CLICK = 'SHIPPING_ADDRESS_CONTINUE_CLICK';

export const EXPRESS_CHECKOUT_VALIDATE_ORDER = 'EXPRESS_CHECKOUT_VALIDATE_ORDER';

export const EXPRESS_CHECKOUT_SIDE_DRAWER = 'EXPRESS_CHECKOUT_SIDE_DRAWER';
export const EXPRESS_CHECKOUT_PERK_UP_SELL_ENABLE = 'EXPRESS_CHECKOUT_PERK_UP_SELL_ENABLE';

export const EXPRESS_CHECKOUT_ADD_FEATURE_PERK = 'EXPRESS_CHECKOUT_ADD_FEATURE_PERK';

export const EXPRESS_CHECKOUT_SELECTED_PERKS = 'EXPRESS_CHECKOUT_SELECTED_PERKS';
export const EXPRESS_CHECKOUT_SELECTED_PERKS_ADD = 'EXPRESS_CHECKOUT_SELECTED_PERKS_ADD';
export const EXPRESS_CHECKOUT_SELECTED_PERKS_REMOVE = 'EXPRESS_CHECKOUT_SELECTED_PERKS_REMOVE';

export const ADD_PERK_BUTTON_CLICK = 'ADD_PERK_BUTTON_CLICK';
export const INIT_PERK_SELECTION_EXPRESS_CHECKOUT = 'INIT_PERK_SELECTION_EXPRESS_CHECKOUT';
export const INIT_PERK_SELECTION_PROSPECT_CHECKOUT = 'INIT_PERK_SELECTION_PROSPECT_CHECKOUT';
export const SHOW_PERK_NOTIFICATION = 'SHOW_PERK_NOTIFICATION';
export const UPDATE_EXPRESSTOS_CHECKOUT_COMPLETE = 'UPDATE_EXPRESSTOS_CHECKOUT_COMPLETE';

export const API_STATUS = {
    IN_PROGRESS: 'IN_PROGRESS',
    SUCCESS: 'SUCCESS',
    FAILED: 'FAILED',
};